import styled from '@emotion/styled';
import { css } from 'emotion';
import { colors } from '../../../constants/theme';
import { arrow } from '../../../constants/classes/arrow';
import Button from '../Button';

export const BackToListBtn = styled(Button)`
  && {
    background: url('../../../../assets/icons/back-to-list.svg') no-repeat 18px;
    background-size: 20px 11px;
    padding-left: 48px;
    margin: 0 10px;
    background-color: ${({ theme }) => theme.colors.whiteMediumBackground};
  }
`;

export const ButtonGroup = styled.div`
  width: 375px;
  display: flex;
  justify-content: space-between;
  margin-top: auto;
`;

export const nextBtnLabel = css`
  ::after {
    ${arrow};
    top: 7px;
    right: 11px;
    border-color: ${colors.greySecondary};
    border-width: 2px;
    transform: rotate(-135deg);
  }
`;

export const previuosBtnLabel = css`
  ::before {
    ${arrow};
    left: 0;
    top: 7px;
    border-color: ${colors.greySecondary};
    border-width: 2px;
    transform: rotate(45deg);
  }
`;

export const switchItemButton = css`
  :focus > span,
  :active > span {
    position: static;
  }
  :disabled {
    .prev-btn:before,
    .next-btn:after {
      border-color: ${colors.greyInputBorder};
    }
  }
`;
